// // frontend/src/components/Admin/sidebar.js

// import React from "react";
// import { Link } from "react-router-dom";
// import { ReactComponent as Logo } from "../../assets/SenseAbleIcon.svg";
// import { useSelector } from "react-redux";
// import { Badge } from "react-bootstrap"; 
// import "./AdminCSS/alertpage.css";

// const Sidebar = ({ onOptionClick }) => {
//   // Get unacknowledged alerts count from Redux alerts slice
//   const alerts = useSelector((state) => state.alerts.alerts || []);
//   const unacknowledgedCount = alerts.filter((alert) => !alert.acknowledged).length;
//   const unreadCount = useSelector(
//     (state) => state.notifications.notifications.length
//     // state.notifications.notifications.filter((alert) => !alert.read).length
//   );

//   return (
//     <div className="custom-sidebar">
//       <div className="logo text-center py-3">
//         <Logo className="sidebar-logo" />
//       </div>
//       <ul className="sidebar-menu">
//         <li>
//           <Link to="#" onClick={() => onOptionClick("dashboard")}>
//             Dashboard
//           </Link>
//         </li>
//         <li className="dropdown">
//           <span>Operations</span>
//           <ul className="dropdown-menu">
//             <li>
//               <Link to="/admin/adduser">Add User</Link>
//             </li>
//             <li>
//               <Link to="/admin/adddevice">Add Device</Link>
//             </li>
//             <li>
//               <Link to="/admin/addadmin">Add Admin</Link>
//             </li>
//             <li>
//               <Link to="/admin/addpatient">Add Patient</Link>
//             </li>
//             <li>
//               <Link to="/admin/assign-device">Assign Device</Link>
//             </li>
//             <li>
//               <Link to="/admin/assign-user">Assign User</Link>
//             </li>
//           </ul>
//         </li>
//         <li>
//           <Link to="#" onClick={() => onOptionClick("users")}>
//             Users
//           </Link>
//         </li>
//         <li>
//           <Link to="#" onClick={() => onOptionClick("admins")}>
//             Admins
//           </Link>
//         </li>
//         <li>
//           <Link to="#" onClick={() => onOptionClick("devices")}>
//             Devices
//           </Link>
//         </li>
//         <li>
//           <Link to="#" onClick={() => onOptionClick("patients")}>
//             Patients
//           </Link>
//         </li>
//         {/* <li>
//           <Link to="#" onClick={() => onOptionClick("bluetooth-wifi-connect")}>
//             BluetoothWiFiConnect
//           </Link>
//         </li> */}
//          <li>
//           <Link to="#" onClick={() => onOptionClick("admin-alerts")}>
//           Alerts
//             {/* Show badge After Alerts text if there are any unacknowledged alerts */}
//             {unacknowledgedCount > 0 && (
//               <Badge bg="danger" pill className="me-1">
//                 {unacknowledgedCount}
//               </Badge>
//             )}
            
//           </Link>
//         </li>
//         {/* <li>
//           <Link to="#" onClick={() => onOptionClick("fall-alerts")}>
//             Fall Alerts{" "}
//             {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
//           </Link>
//         </li> */}
//         <li>
//           <Link to="settings">Settings</Link>
//         </li>
//       </ul>
//     </div>
//   );
// };

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/SenseAbleIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import { Badge } from "react-bootstrap";
import "./AdminCSS/alertpage.css";

// Watch alerts (AlertSlice → state.alerts)
import { fetchAllAlerts as fetchAllWatchAlerts } from "../../redux/slices/AlertSlice";
// Fall alerts (AlertTableSlice → state.fallAlerts)
import { fetchAllFallAlerts } from "../../redux/slices/AlertTableSlice";

const Sidebar = ({ onOptionClick }) => {
  const dispatch = useDispatch();

  // ── Fetch both alert types on mount so counts show immediately ──
  useEffect(() => {
    dispatch(fetchAllWatchAlerts());
    // dispatch(fetchAllFallAlerts());
  }, [dispatch]);

  // Watch alerts → state.alerts
  const watchAlerts = useSelector((state) => state.alerts.alerts || []);
  const watchUnacknowledged = watchAlerts.filter((a) => !a.acknowledged).length;

  // Fall alerts → state.fallAlerts
  // const fallAlerts = useSelector((state) => state.fallAlerts.alerts || []);
  // const fallUnacknowledged = fallAlerts.filter((a) => !a.alert_acknowledged).length;

  // Combined badge count
  const totalUnacknowledged = watchUnacknowledged;

  return (
    <div className="custom-sidebar">
      <div className="logo text-center py-3">
        <Logo className="sidebar-logo" />
      </div>

      <ul className="sidebar-menu">
        <li>
          <Link to="#" onClick={() => onOptionClick("dashboard")}>
            Dashboard
          </Link>
        </li>

        {/* ================= OPERATIONS DROPDOWN ================= */}
        <li className="dropdown">
          <span>Operations</span>
          <ul className="dropdown-menu">
            <li><Link to="/admin/adduser">Add User</Link></li>
            <li><Link to="/admin/adddevice">Add Device</Link></li>
            <li><Link to="/admin/addadmin">Add Admin</Link></li>
            <li><Link to="/admin/addpatient">Add Patient</Link></li>
            <li><Link to="/admin/assign-device">Assign Device</Link></li>
            <li><Link to="/admin/assign-user">Assign User</Link></li>
          </ul>
        </li>

        <li>
          <Link to="#" onClick={() => onOptionClick("users")}>
            Users
          </Link>
        </li>

        <li>
          <Link to="#" onClick={() => onOptionClick("admins")}>
            Admins
          </Link>
        </li>

        <li>
          <Link to="#" onClick={() => onOptionClick("devices")}>
            Devices
          </Link>
        </li>

        <li>
          <Link to="#" onClick={() => onOptionClick("patients")}>
            Patients
          </Link>
        </li>

        {/* ================= ALERTS DROPDOWN ================= */}
        {/* <li className="dropdown">
          <Link
            to="#"
            onClick={() => onOptionClick("fall-alerts")}
            className="d-flex align-items-center"
          >
            Alerts
            {totalUnacknowledged > 0 && (
              <Badge bg="danger" pill className="ms-2">
                {totalUnacknowledged}
              </Badge>
            )}
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link to="#" onClick={() => onOptionClick("fall-alerts")}>
                Fall Alerts
              </Link>
            </li>
            <li>
              <Link to="#" onClick={() => onOptionClick("watch-alerts")}>
                Watch Alerts
              </Link>
            </li>
          </ul>
        </li> */}
        {/* ================= ALERTS ================= */}
        <li>
          <Link
            to="#"
            onClick={() => onOptionClick("fall-alerts")}
            className="d-flex align-items-center"
          >
            Alerts

            {totalUnacknowledged > 0 && (
              <Badge bg="danger" pill className="ms-2">
                {totalUnacknowledged}
              </Badge>
            )}
          </Link>
        </li>

        <li>
          <Link to="settings">Settings</Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;